import { IconNext } from 'components/ui/icons';
import styles from '../control-track.module.scss';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { trackSwith } from 'store/slices/player.slices';
import { FC } from 'react';

export const BtnNextTrack = () => {
  const dispatch = useAppDispatch();

  /* Индекс активного трека, массив список треков */
  const { activeTrackNum, trakList } = useAppSelector((store) => store.player);

  /* Пеерключает на след трек если он не последний в списке */
  const onNextTrack = () => {
    if (trakList.length > activeTrackNum + 1) {
      dispatch(trackSwith(activeTrackNum + 1));
    }
  };

  return (
    <button className={styles.btn} onClick={onNextTrack}>
      <IconNext />
    </button>
  );
};
